"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constant_1 = require("./constant");
const enums_1 = require("./enums");
exports.default = {
    handlerError(errorMessage, validationIdType) {
        switch (validationIdType) {
            case enums_1.ValidtionIdType.THROW_ERROR:
                throw new Error(errorMessage);
            case enums_1.ValidtionIdType.RETURN_FALSE:
                return false;
            default:
                // default is ValidtionIdType.THROW_ERROR
                throw new Error(errorMessage);
        }
    },
    padToIdString(id, digitType, isPadStart = true) {
        return (isPadStart)
            ? id.toString().padStart(digitType, '0')
            : id.toString().padEnd(digitType, '0');
    },
    isStringOFNumber(value) {
        return (typeof value === 'string'
            && value.trim() !== ''
            && !Number.isNaN(Number(value)));
    },
    formatWithFormatType(idStr, format) {
        const idStrArr = idStr.split('');
        return format
            .split('')
            .reduce((sum, char) => sum + ((char === '0') ? idStrArr.shift() : char), '');
    },
    calcDigit(idStr, digitType) {
        // TODO: wait approve
        // const sum: number = idStr
        //   .substring(0, idStr.length - 1) // remove last element
        //   .split('')
        //   // .filter((_, i) => (i !== idStr.length - 1)) // remove last element
        //   .map(char => Number(char))
        //   .reduce((sum, char, i) =>
        //     (sum + (char * (digitType - i + 2))),
        //     0,
        //   )
        let sum = 0;
        for (let i = 1; i < digitType; i++) {
            sum += Number(idStr.substr(i - 1, 1)) * (digitType + 1 - i);
        }
        return (11 - (sum % 11)) % 10;
    },
    getErrorWithValidationId(id, digitType, diff = 0) {
        if (!Number.isInteger(id))
            return 'id ต้องเป็นตัวเลขจำนวนเต็ม';
        if (id <= 0)
            return 'id ต้องมากกว่า 0';
        if (id.toString().length > digitType + diff) {
            return `ขนาดของ id มีความยาวมากกว่า ${digitType + diff} ตัวอักษร.`;
        }
        if (id.toString().length < constant_1.ID_MIN_LENGTH + diff) {
            return `ขนาดของ id มีความยาวน้อยกว่า ${constant_1.ID_MIN_LENGTH + diff} ตัวอักษร.`;
        }
        return '';
    },
    getErrorWithCheckIdIsNumber(id) {
        if (Number.isNaN(id))
            return 'id ต้องเป็น number หรือ string of number';
        if (typeof id === 'string' && !this.isStringOFNumber(id))
            return 'id ต้องเป็น number หรือ string of number';
        return '';
    },
};
